import "./puja-campaign-btn.scss";
import Image from "next/image";

import btnBg from "@/../public/campaign/puja-2025/btn-bg.png";
import bigBtnBg from "@/../public/campaign/puja-2025/big-btn-bg.png";

export default function Btn({ btnTxt, onClick, isLoading, isBigBtn }) {
  return (
    <button
      className="flex-row-center PujaCampaignBtn"
      onClick={onClick}
      disabled={isLoading}
      style={{ width: isBigBtn ? "30vh" : "23vh" }}
    >
      <Image src={isBigBtn ? bigBtnBg : btnBg} alt="logo" className="btnBg" />
      {isLoading ? (
        <div className="pujaCampaignBtnLoader"></div>
      ) : (
        <p className="btnText">{btnTxt}</p>
      )}
    </button>
  );
}
